// Hero-categories accordion (mobile only).
//
// On screens ≤ 1023px each parent row with children acts as an
// accordion drawer: first tap toggles its subcategory panel open
// (or closed if already open). Tapping a sub-link inside the drawer
// navigates as normal. Only ONE drawer is open at a time.
//
// Desktop (≥ 1024px) keeps the existing hover-flyout behavior — the
// matchMedia gate below ensures none of this JS runs there.

const MOBILE_QUERY = '(max-width: 1023px)';
const mq = window.matchMedia(MOBILE_QUERY);

function closeAll(scope) {
    scope.querySelectorAll('.hero-categories__row.is-open').forEach((r) => r.classList.remove('is-open'));
}

function handleTap(event) {
    if (!mq.matches) return;                       // desktop — let the normal link work

    const link = event.target.closest('.hero-categories__link');
    if (!link) return;
    const row = link.closest('.hero-categories__row');
    if (!row || !row.classList.contains('has-children')) return;

    // ALWAYS toggle — the parent link never navigates on mobile, it
    // only opens/closes the accordion. To reach the parent category
    // archive itself, users tap the "View all" link injected at the
    // top of the open drawer (see ensureViewAllLink below).
    event.preventDefault();

    const isOpen = row.classList.contains('is-open');
    const scope  = row.closest('.hero-categories') || document;

    if (isOpen) {
        row.classList.remove('is-open');
    } else {
        closeAll(scope);
        ensureViewAllLink(row);
        row.classList.add('is-open');
    }
}

/**
 * Add a "View all" link to the top of a parent's flyout, pointing at
 * the parent's own archive URL. Idempotent — only inserts once per row.
 * Lets users reach the parent term page even though tapping the parent
 * header just toggles the accordion now.
 */
function ensureViewAllLink(row) {
    const flyout = row.querySelector(':scope > .hero-categories__flyout');
    if (!flyout || flyout.querySelector('.hero-categories__view-all')) return;

    const parentLink = row.querySelector(':scope > .hero-categories__link');
    if (!parentLink) return;

    const labelEl = parentLink.querySelector('.hero-categories__label');
    const parentName = labelEl ? labelEl.textContent.trim() : 'all';

    const li = document.createElement('li');
    li.className = 'hero-categories__sub hero-categories__sub--view-all';
    li.setAttribute('role', 'none');

    const a = document.createElement('a');
    a.className = 'hero-categories__sub-link hero-categories__view-all';
    a.setAttribute('role', 'menuitem');
    a.href = parentLink.getAttribute('href') || '#';
    // Point the arrow the reading direction (← in RTL/Hebrew, → in LTR).
    const arrow = (document.documentElement.getAttribute('dir') === 'rtl') ? '←' : '→';
    a.textContent = `${arrow} ${parentName}`;

    li.appendChild(a);
    flyout.insertBefore(li, flyout.firstChild);
}

function bind() {
    document.querySelectorAll('[data-hero-categories]').forEach((host) => {
        // Idempotent — only attach once.
        if (host.dataset.heroAccordionBound) return;
        host.dataset.heroAccordionBound = '1';
        host.addEventListener('click', handleTap);
    });
}

// When the viewport crosses the breakpoint, clear any stale state so
// resizing from mobile → desktop doesn't leave a row stuck in
// `.is-open` (would conflict with the desktop hover styling).
function onBreakpointChange() {
    if (!mq.matches) {
        document.querySelectorAll('.hero-categories__row.is-open').forEach((r) => r.classList.remove('is-open'));
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
} else {
    bind();
}

mq.addEventListener?.('change', onBreakpointChange);
